import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonTitle from '../../../common-components/common-title';
import CommonOlList from '../../../common-components/common-ol-list';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import BigImgScroll from '../../../common-components/big-img-scroll';

const list = {
    colorNumber: '#3498dc',
    list: [
        `Из&nbsp;90&nbsp;ключевых слов в&nbsp;11&nbsp;городах и&nbsp;двух поисковых системах получается 1980&nbsp;результатов, которые нужно получить.`,
        `За&nbsp;6&nbsp;месяцев работ удалось получить 483 запроса в&nbsp;ТОП-3 и&nbsp;1060 запросов в&nbsp;ТОП-10.`,
    ],
};

const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="nanoteh-results">
                <CommonTitle className="nanoteh-results__title">Результаты</CommonTitle>
                <div className="nanoteh-results__items">
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="nanoteh-results__item-body"
                    >
                        <div className="nanoteh-results__item-img">
                            <BigImgScroll img="/images/pic/nanotech/nanoteh-results__item-img1.png" />
                        </div>
                        <div className="nanoteh-results__item-info">
                            <CommonSmallTitle className="nanoteh-results__item-title">
                                01. Рост видимости по&nbsp;запросам увеличился в&nbsp;2&nbsp;раза
                            </CommonSmallTitle>
                            <CommonSmallText className="nanoteh-results__item-subtitle">
                                Видимость&nbsp;&mdash; это доля показов сайта в&nbsp;продвигаемых
                                регионах по&nbsp;выбранной семантике.
                            </CommonSmallText>
                            <CommonSmallText className="nanoteh-results__link">
                                <a
                                    className="nanoteh__link"
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                    href="https://allpositions.ru/reports/guest/index/910731/604f926526075250e93f13b4f15e8e3e"
                                >
                                    Посмотреть детальный график
                                </a>
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="nanoteh-results__item-body nanoteh-results__item-body--middle"
                    >
                        <div className="nanoteh-results__item-info">
                            <CommonSmallTitle className="nanoteh-results__item-title">
                                02. Улучшение позиций в&nbsp;ТОП-3 фраз поисковика в&nbsp;5&nbsp;раз
                                и&nbsp;ТОП-10&nbsp;в 4&nbsp;раза
                            </CommonSmallTitle>
                            <CommonOlList CommonOlList={list} />
                        </div>
                        <div className="nanoteh-results__query-container">
                            <div className="nanoteh-results__query-item">
                                <div className="nanoteh-results__query-title">Запросов в ТОП-3</div>
                                <div className="nanoteh-results__query-data">
                                    <div className="nanoteh-results__query-cipher">483</div>
                                    <div className="nanoteh-results__query-num">
                                        <img
                                            className="nanoteh-results__query-decor"
                                            src="/images/svg/converter/triangle.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        24%
                                    </div>
                                </div>
                            </div>
                            <div className="nanoteh-results__query-item">
                                <div className="nanoteh-results__query-title">
                                    Запросов в ТОП-10
                                </div>
                                <div className="nanoteh-results__query-data">
                                    <div className="nanoteh-results__query-cipher">1 060</div>
                                    <div className="nanoteh-results__query-num">
                                        <img
                                            className="nanoteh-results__query-decor"
                                            src="/images/svg/converter/triangle.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        54%
                                    </div>
                                </div>
                            </div>
                            <div className="nanoteh-results__query-item">
                                <div className="nanoteh-results__query-title">
                                    Запросов в ТОП-30
                                </div>
                                <div className="nanoteh-results__query-data">
                                    <div className="nanoteh-results__query-cipher">1 436</div>
                                    <div className="nanoteh-results__query-num">
                                        <img
                                            className="nanoteh-results__query-decor"
                                            src="/images/svg/converter/triangle.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        73%
                                    </div>
                                </div>
                            </div>
                            <div className="nanoteh-results__query-item">
                                <div className="nanoteh-results__query-title">
                                    Позиций улучшилось
                                </div>
                                <div className="nanoteh-results__query-data">
                                    <div className="nanoteh-results__query-cipher">795</div>
                                    <div className="nanoteh-results__query-num">
                                        <img
                                            className="nanoteh-results__query-decor"
                                            src="/images/svg/converter/triangle.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        40%
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
                <ScrollAnimation
                    animateIn="fadeIn"
                    offset={100}
                    animateOnce={true}
                    duration={1}
                    className="nanoteh-results__item-body"
                >
                    <div className="nanoteh-results__item-img">
                        <BigImgScroll img="/images/pic/nanotech/nanoteh-results__item-img2.png" />
                    </div>
                    <div className="nanoteh-results__item-info">
                        <CommonSmallTitle className="nanoteh-results__item-title">
                            03. Рост трафика сайта увеличился в&nbsp;2&nbsp;раза за&nbsp;полгода
                            работы
                        </CommonSmallTitle>
                        <CommonSmallText className="nanoteh-results__item-subtitle">
                            График согласно Яндекс-метрике
                        </CommonSmallText>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
